// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2TIB_","range":"MonthRangeSwitch_range__BfC0k","disabled":"MonthRangeSwitch_disabled__16kyY"};